import React, { useEffect } from 'react';

import UserPrefsManager from './user_prefs';
import axiosInstance from '../components/axios';
import obvmConfig from '../config';

// MaterialUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { Divider } from '@mui/material';


// Get frontend version and copyright year from config
const FRONTEND_VERSION = obvmConfig.APP.VERSION;
const FRONTEND_VERSION_DATE = obvmConfig.APP.VERSION_DATE;
const COPYRIGHT_YEAR = obvmConfig.APP.COPYRIGHT_YEAR;

export default function Footer() {

	const [apiVersionInfo, setAPIVersionInfo] = React.useState({
		api_version: null,
		api_version_date: null,
	});

	// On mount, get API version info from state, local storage, or API
	useEffect(() => {
		if (!apiVersionInfo.api_version && !apiVersionInfo.api_version_date) {
			const apiVersion = UserPrefsManager.get('apiVersion');
			const apiVersionDate = UserPrefsManager.get('apiVersionDate');
			
			if (apiVersion && apiVersionDate) {
				// set the state from local storage
				setAPIVersionInfo({
					api_version: apiVersion,
					api_version_date: apiVersionDate,
				});
			} else {
				// Fetch from the API
				axiosInstance.get(`/info/version/`)
					.then(response => {
						if (response.data?.api_version && response.data?.api_version_date) {
							setAPIVersionInfo({
								api_version: response.data.api_version,
								api_version_date: response.data.api_version_date,
							});

							UserPrefsManager.set('apiVersion', response.data.api_version);
							UserPrefsManager.set('apiVersionDate', response.data.api_version_date);
						}
					})
					.catch(error => {
						console.error("Error fetching API version info: ", error);
					});
			}
		}

	}, []);

	function Copyright() {
		return (
			<Typography variant="body2" color="text.secondary" align="center">
				{`Copyright © ${COPYRIGHT_YEAR}`}
				<Link color="inherit" href="https://www.btechinc.com/" paddingLeft={0.5}>BTECH, Inc.</Link>
			</Typography>
		);
	}

	function FrontendVersion() {
		return (
			<Typography variant="body2" color="text.secondary" align="center">
				OBVM: v{FRONTEND_VERSION} ({FRONTEND_VERSION_DATE})
			</Typography>
		);
	}

	function APIVersion() {
		const apiText = apiVersionInfo.api_version && apiVersionInfo.api_version_date ?
			`v${apiVersionInfo.api_version} (${apiVersionInfo.api_version_date})` : 'Not Available';

		return (
			<Typography variant="body2" color="text.secondary" align="center">
				API: {apiText}
			</Typography>
		);
	}

	return (
		<Box
			component="footer"
			sx={{
				pt: 1,
				pb: 0.5,
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				justifyContent: 'center',
				gap: 3,
			}}
		>
			<Copyright />
			<Divider orientation="vertical" flexItem />
			<FrontendVersion />
			<Divider orientation="vertical" flexItem />
			<APIVersion />
		</Box>
	);
}